import React from "react";
import "./SkeletonLoaders.css";

/**
 * Skeleton loader for CompactCard in the half-expanded list
 */
export const CompactCardSkeleton = () => (
  <div className="skeleton-compact-card">
    <div className="skeleton-compact-card-main">
      <div className="skeleton-compact-card-info">
        <div className="skeleton-bar skeleton-name" />
        <div className="skeleton-bar skeleton-meta" />
      </div>
      <div className="skeleton-bar skeleton-chevron" />
    </div>
  </div>
);

/**
 * Skeleton loader for the half-expanded list view
 */
export const CompactListSkeleton = ({ count = 6 }) => (
  <div className="skeleton-compact-list">
    {Array.from({ length: count }).map((_, i) => (
      <CompactCardSkeleton key={i} />
    ))}
  </div>
);

/**
 * Skeleton loader for RestaurantCard in the carousel
 */
export const RestaurantCardSkeleton = () => (
  <div className="skeleton-restaurant-card">
    <div className="skeleton-bar skeleton-card-name" />
    <div className="skeleton-bar skeleton-card-meta" />
    <div className="skeleton-card-chips">
      <div className="skeleton-bar skeleton-chip" />
      <div className="skeleton-bar skeleton-chip" />
      <div className="skeleton-bar skeleton-chip" />
    </div>
  </div>
);

/**
 * Skeleton loader for the carousel view
 */
export const CarouselSkeleton = () => (
  <div className="skeleton-carousel">
    <RestaurantCardSkeleton />
  </div>
);
